/** Reads the body of `response`; a non-OK status rejects with
 *  `{label} request failed with {status}` before the body is read. */
export const readBodyOrThrow = async (
  response: Response,
  label: string
): Promise<void> => {
  if (!response.ok)
    throw new Error(
      `${label} request failed with ${response.status.toString()}`
    );
  await response.arrayBuffer();
};
